import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let SegmentsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-segments';
        }
    }
});
export const SegmentsPlugin = {
    name: 'e-segments',
    install(Vue) {
        Vue.component(SegmentsPlugin.name, SegmentsDirective);
    }
};
export let SegmentDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-segment';
        }
    }
});
export const SegmentPlugin = {
    name: 'e-segment',
    install(Vue) {
        Vue.component(SegmentPlugin.name, SegmentDirective);
    }
};
